module.exports = __webpack_public_path__ + "img/13-f458fc75.png";